import React from "react";

const DEFAULT_RULES = {
  check_in_time: "16:00",
  check_out_time: "11:00",
  self_check_in: false,
  key_box: false,
  no_parties: true,
  no_smoking: true,
  pets_allowed: false,
  quiet_hours: true,
  max_visitors: 0,
  cleaning_conditions: "",
};

/**
 * RulesEditor — controlled component to edit listing house rules.
 * value: object (partial), onChange: (newRules) => void
 */
export default function RulesEditor({ value, onChange }) {
  const v = { ...DEFAULT_RULES, ...(value || {}) };
  const set = (k, val) => onChange({ ...v, [k]: val });

  const ToggleRow = ({ k, label }) => (
    <label className="flex items-center justify-between gap-3 py-2.5 border-b border-black/5 last:border-0">
      <span className="text-sm">{label}</span>
      <button
        type="button"
        data-testid={`rule-${k}`}
        onClick={() => set(k, !v[k])}
        className={`relative w-11 h-6 rounded-full transition-colors ${v[k] ? "bg-[#0A0A0A]" : "bg-neutral-300"}`}
      >
        <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${v[k] ? "left-[22px]" : "left-0.5"}`} />
      </button>
    </label>
  );

  return (
    <div className="border border-black/10 bg-white" data-testid="rules-editor">
      <div className="px-4 py-3 border-b border-black/10 bg-[#FAFAFA]">
        <div className="text-[11px] uppercase tracking-[0.25em] font-bold">Règles du logement</div>
      </div>
      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-x-6">
        <div>
          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="block">
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-1">Arrivée</div>
              <input data-testid="rule-check_in_time" type="time" value={v.check_in_time} onChange={(e) => set("check_in_time", e.target.value)} className="w-full border border-black/15 p-2 outline-none focus:border-[#0A0A0A]" />
            </label>
            <label className="block">
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-1">Départ</div>
              <input data-testid="rule-check_out_time" type="time" value={v.check_out_time} onChange={(e) => set("check_out_time", e.target.value)} className="w-full border border-black/15 p-2 outline-none focus:border-[#0A0A0A]" />
            </label>
          </div>
          <ToggleRow k="self_check_in" label="Arrivée autonome" />
          <ToggleRow k="key_box" label="Boîte à clés" />
          <ToggleRow k="no_parties" label="Fêtes interdites" />
        </div>
        <div>
          <ToggleRow k="no_smoking" label="Non fumeur" />
          <ToggleRow k="pets_allowed" label="Animaux autorisés" />
          <ToggleRow k="quiet_hours" label="Silence après 22h" />
          <label className="block mt-3">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-1">Nombre max de visiteurs</div>
            <input data-testid="rule-max_visitors" type="number" min={0} value={v.max_visitors} onChange={(e) => set("max_visitors", Number(e.target.value))} className="w-full border border-black/15 p-2 outline-none focus:border-[#0A0A0A]" />
          </label>
        </div>
        <label className="block md:col-span-2 mt-3">
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-1">Conditions de ménage</div>
          <textarea
            data-testid="rule-cleaning_conditions"
            rows={2}
            value={v.cleaning_conditions}
            onChange={(e) => set("cleaning_conditions", e.target.value)}
            placeholder="Ex : vaisselle propre, poubelles sorties, draps déposés dans la salle de bain…"
            className="w-full border border-black/15 p-2 outline-none focus:border-[#0A0A0A]"
          />
        </label>
      </div>
    </div>
  );
}
